import { px, rect, cRect, mRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_cross: Hull = {
  id: 'hull_cross',
  name: 'Cross',
  drawBody: (ctx, p) => {
    cRect(ctx, 22, 4, 18, p.primary); cRect(ctx, 32, 18, 4, p.primary);
    cRect(ctx, 22, 4, 1, p.light); cRect(ctx, 39, 4, 1, p.shadow); cRect(ctx, 32, 18, 1, p.light); cRect(ctx, 35, 18, 1, p.shadow);
    mRect(ctx, 0, 33, 1, 2, p.accent); mRect(ctx, 8, 32, 1, 4, p.dark);
    cRect(ctx, 24, 2, 2, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 26 }, cap: (ctx, p) => cRect(ctx, 28, 4, 1, p.dark) },
    [SLOT.WING_L]:     { anchor: { x: 23, y: 33 }, cap: (ctx, p) => { rect(ctx, 23, 32, 2, 4, p.shadow); rect(ctx, 23, 32, 2, 1, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 40, y: 33 }, cap: (ctx, p) => { rect(ctx, 39, 32, 2, 4, p.shadow); rect(ctx, 39, 32, 2, 1, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 30, y: 40 }, cap: (ctx, p) => { rect(ctx, 29, 39, 3, 2, p.shadow); px(ctx, 29, 39, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 34, y: 40 }, cap: (ctx, p) => { rect(ctx, 32, 39, 3, 2, p.shadow); px(ctx, 34, 39, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 21 }, base: (ctx, p) => { cRect(ctx, 22, 4, 1, p.metalDark); cRect(ctx, 21, 2, 1, p.metal); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 21 } },
  },
};
